import { render, staticRenderFns } from "./drivingLicense.vue?vue&type=template&id=12aefc7d&scoped=true&"
import script from "./drivingLicense.vue?vue&type=script&lang=js&"
export * from "./drivingLicense.vue?vue&type=script&lang=js&"
import style0 from "./drivingLicense.vue?vue&type=style&index=0&id=12aefc7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aefc7d",
  null
  
)

export default component.exports